export const Label = {
  ABORT_BUTTON: "Abbrechen",
  PLACEHOLDER: "Wonach suchst du?",

  TRENDING_QUERY_HEADER: "BELIEBTE SUCHEN",

  HISTORY_HEADER: "DEINE SUCHHISTORIE",
  HISTORY_DELETE_ALL_BUTTON: "Alle löschen",
};
